import { render, staticRenderFns } from "./msv1.vue?vue&type=template&id=83aecba8&scoped=true"
import script from "./msv1.vue?vue&type=script&lang=js"
export * from "./msv1.vue?vue&type=script&lang=js"
import style0 from "./msv1.vue?vue&type=style&index=0&id=83aecba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aecba8",
  null
  
)

export default component.exports